function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import renderTemplateImpl from '../renderTemplate';
import { basicTemplate as basicTemplateImpl } from './basicTemplate';
import { track } from '../../../tracking';
import { withAdClickedEvent } from '../../../tracking/events';

var BasicAdComponent = /*#__PURE__*/function () {
  function BasicAdComponent(adType, shouldTrackEvent) {
    var renderTemplate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : renderTemplateImpl;
    var basicTemplate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : basicTemplateImpl;

    _classCallCheck(this, BasicAdComponent);

    this.adType = adType;
    this.shouldTrackEvent = shouldTrackEvent;
    this.renderTemplate = renderTemplate;
    this.basicTemplate = basicTemplate;
    this.isLeadAd = adType === 'basic-lead';
  }

  _createClass(BasicAdComponent, [{
    key: "addAdClickEventListeners",
    value: function addAdClickEventListeners(renderTarget, adSpot, adContentJson) {
      var _this = this;

      var brandClickElement = renderTarget.getElementsByClassName('native-basic__brand')[0];
      var imageElementClassName = this.isLeadAd ? '.native-basic__image' : '.native-basic__image a';
      var imageClickElement = renderTarget.querySelector(imageElementClassName);
      var textClickElement = renderTarget.getElementsByClassName('native-basic__text')[0];
      var ctaElementsClassName = this.isLeadAd ? 'native-basic__action-button' : 'native-basic__action-link';
      var ctaElements = renderTarget.getElementsByClassName(ctaElementsClassName);
      var clickElements = [brandClickElement, imageClickElement, textClickElement].concat(_toConsumableArray(ctaElements));
      clickElements.forEach(function (element) {
        return element && element.addEventListener('click', function (event) {
          if (_this.isLeadAd) {
            adSpot.leadClickCallback(_this.toLeadAdJson(adContentJson));

            if (element === ctaElements[0]) {
              event.stopPropagation();
            }
          }

          track(withAdClickedEvent(), adSpot, _this.shouldTrackEvent);
        });
      });
    }
  }, {
    key: "addTermsEventListeners",
    value: function addTermsEventListeners(renderTarget) {
      var termsOpenButton = renderTarget.getElementsByClassName('native-basic__terms-open-button')[0];

      if (!termsOpenButton) {
        return;
      }

      var termsCloseButton = renderTarget.getElementsByClassName('native-basic__terms-close-button')[0];

      if (!termsCloseButton) {
        return;
      }

      var overlay = renderTarget.getElementsByClassName('native-basic__card-overlay')[0];

      if (!overlay) {
        return;
      }

      termsOpenButton.addEventListener('click', function () {
        return overlay.classList.add('show');
      });
      termsCloseButton.addEventListener('click', function () {
        return overlay.classList.remove('show');
      });
    }
  }, {
    key: "render",
    value: function render(adContentJson, renderTarget, adSpot) {
      var _this2 = this;

      adContentJson.isLeadAd = this.isLeadAd;
      return this.renderTemplate(renderTarget, adContentJson, this.basicTemplate).then(function () {
        _this2.addAdClickEventListeners(renderTarget, adSpot, adContentJson);

        _this2.addTermsEventListeners(renderTarget);
      });
    }
  }, {
    key: "toLeadAdJson",
    value: function toLeadAdJson(processedJson) {
      return {
        adtype: processedJson.adtype,
        brandlogourl: processedJson.brandlogourl,
        projecttitle: processedJson.projecttitle,
        addescription: processedJson.addescription,
        actionurl: processedJson.actionurl,
        impressionurl: processedJson.impressionurl,
        leadcompleteurl: processedJson.leadcompleteurl,
        enquirysubmissionurl: processedJson.enquirysubmissionurl,
        lmscampaignid: processedJson.lmscampaignid,
        admessagetext: processedJson.admessagetext,
        heroimageurl: processedJson.heroimageurl
      };
    }
  }]);

  return BasicAdComponent;
}();

export default BasicAdComponent;
//# sourceMappingURL=BasicAdComponent.js.map